import React from "react";

import "./index.css";
import App from "./App";

import "aos/dist/aos.css";

import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import ErrorBoundary from "components/atoms/ErrorBoundary";
import InitializationService from "services/initialization.service";
import { render } from "react-dom";
import TagManager from "react-gtm-module";
import "./locales/config";
const tagManagerArgs = {
  gtmId: "GTM-M8DVB8B8", // replace with your GTM ID
};

TagManager.initialize(tagManagerArgs);
InitializationService.init();

render(
  // <React.StrictMode>
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  // </React.StrictMode>,
  document.getElementById("root")
);
// render(
//   <React.StrictMode>
//     <ErrorBoundary>
//       <App />
//     </ErrorBoundary>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// if (config.NODE_ENV === "development")
serviceWorkerRegistration.unregister();
// else if (config.NODE_ENV === "production")
// 	serviceWorkerRegistration.register({
// 		onUpdate: (reg, message) => log("pwa onUpdate", reg.scope, message),
// 		onSuccess: (reg, message) => log("pwa onSuccess", reg.scope, message),
// });

reportWebVitals();
